exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-feedback{padding:20px}.app-feedback .search-content{margin-bottom:20px}.app-feedback .search-content .search-group{display:inline-block;border:1px solid #d6d6d6;border-radius:4px}.app-feedback .search-content .search-group .drop-menu-stage{border:none;width:120px;border-right:1px solid #d6d6d6;border-top-right-radius:0;border-bottom-right-radius:0}.app-feedback .search-content .search-group .input-box-wrap{border:none}.app-feedback .feed-content{width:500px;display:inline-block;padding:0;overflow:hidden;text-overflow:ellipsis}.app-feedback .remark-pop textarea{padding:10px;width:100%;height:100px}.app-feedback .show-remark{text-align:center}.app-feedback .show-remark h3{margin-bottom:20px;font-weight:700}.app-feedback .show-remark p{word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/user/app-feedback/app-feedback.scss
// module id = 554
// module chunks = 2